/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Show_WordsInputs */

const en_options_metrics_show_words = /** @type {(inputs: Options_Metrics_Show_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Total Words`)
};

const fr_options_metrics_show_words = /** @type {(inputs: Options_Metrics_Show_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Total Words`)
};

const de_options_metrics_show_words = /** @type {(inputs: Options_Metrics_Show_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Total Words`)
};

const it_options_metrics_show_words = /** @type {(inputs: Options_Metrics_Show_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Total Words`)
};

const ru_options_metrics_show_words = /** @type {(inputs: Options_Metrics_Show_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Total Words`)
};

const es_options_metrics_show_words = /** @type {(inputs: Options_Metrics_Show_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Total Words`)
};

const zh_cn2_options_metrics_show_words = /** @type {(inputs: Options_Metrics_Show_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Total Words`)
};

const ja_options_metrics_show_words = /** @type {(inputs: Options_Metrics_Show_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Total Words`)
};

const hi_options_metrics_show_words = /** @type {(inputs: Options_Metrics_Show_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Total Words`)
};

const pt_pt2_options_metrics_show_words = /** @type {(inputs: Options_Metrics_Show_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Total Words`)
};

/**
* | output |
* | --- |
* | "Show Total Words" |
*
* @param {Options_Metrics_Show_WordsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_show_words = /** @type {((inputs?: Options_Metrics_Show_WordsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Show_WordsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_show_words(inputs)
	if (locale === "de") return de_options_metrics_show_words(inputs)
	if (locale === "it") return it_options_metrics_show_words(inputs)
	if (locale === "ru") return ru_options_metrics_show_words(inputs)
	if (locale === "es") return es_options_metrics_show_words(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_show_words(inputs)
	if (locale === "ja") return ja_options_metrics_show_words(inputs)
	if (locale === "hi") return hi_options_metrics_show_words(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_show_words(inputs)
	return en_options_metrics_show_words(inputs)
});